import { CLEAR_MESSAGE, SET_MESSAGE } from "../actions/type";

const initialState = { type: "", message: "", display: false, modal: false };

const messageReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MESSAGE:
      return {
        ...state,
        type: payload.type,
        message: payload.message,
        display: true,
      };

    case CLEAR_MESSAGE:
      return initialState;

    default:
      return state;
  }
}
export default messageReducer